import { ClockCircleOutlined } from "@ant-design/icons";
import { Tag } from "antd";

type ActiveCheckInBadgeProps = {
  activeTimeTracking: number | null | undefined;
};

// Deliberately renders no number. `active_time_tracking` counts open time-tracking
// rows, and check-in creates one row per work-order assignee rather than one for the
// technician who actually checked in, so the count reads as the assignee total. It is
// only trustworthy as "somebody is checked in". Null means the serving endpoint did
// not annotate the queryset (the field app), which is indistinguishable here from
// nobody being checked in, so it reads as not active.
export const ActiveCheckInBadge = ({ activeTimeTracking }: ActiveCheckInBadgeProps) => {
  if ((activeTimeTracking ?? 0) <= 0) return null;

  return (
    <Tag color="success" icon={<ClockCircleOutlined />}>
      Checked In
    </Tag>
  );
};
